export default "<app-loader></app-loader>";